export default {
    LOGIN_WIDGET: 'LOGIN_WIDGET',
    LOGOUT_WIDGET: 'LOGOUT_WIDGET',
    LOGIN_USING_OAUTH: 'LOGIN_USING_OAUTH',
    LOGOUT_USING_OAUTH: 'LOGOUT_USING_OAUTH'
}
